const marqueeSection = document.querySelector('.marquee-section');

const cardProduct = document.querySelectorAll('.card-product');

const productQuantityAdd = document.querySelector(".product-qty-container .qty-add");
const productQuantityMinus = document.querySelector(".product-qty-container .qty-minus");
const productQuantityInput = document.querySelector(".product-qty-container input");

const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
const navCloser = document.querySelector('.site-header__icons-wrapper button');
if(mobileNavOverlay) {
  mobileNavOverlay.addEventListener("click", () => {
	navCloser.click();                       
  });
}

if(productQuantityAdd) {
  productQuantityAdd.addEventListener('click', () => {
       productQuantityInput.value = +productQuantityInput.value + 1;                              
});
  
  productQuantityMinus.addEventListener('click', () => {
	if(productQuantityInput.value > 1) {
    	productQuantityInput.value = +productQuantityInput.value - 1;    
  	}
  });
}


if (cardProduct.length) {

    const productGridParents = document.querySelectorAll(".product-index-grid");

    if (productGridParents.length) {
        productGridParents.forEach(gridParent => {
            const scrollLeftIcon = gridParent.querySelector('.scroll_icon.left');
            const scrollRightIcon = gridParent.querySelector('.scroll_icon.right');

            if (scrollLeftIcon) {
                scrollLeftIcon.addEventListener('click', () => {
                    gridParent.scrollLeft = Math.round(gridParent.scrollLeft - (document.body.offsetWidth / 2));
                });
            }

            if (scrollRightIcon) {
                scrollRightIcon.addEventListener('click', () => {
                    gridParent.scrollLeft = Math.round(gridParent.scrollLeft + (document.body.offsetWidth / 2));
                });
            }
        });
    }

    cardProduct.forEach(product => {
        const productForm = product.querySelector('form');
        const cardSwatches = product.querySelectorAll('.swatch-element.color input');
        const prodSelect = product.querySelector('select[name="id"]');
        if (productForm) {
            productForm.addEventListener('change', () => {
                let txt = "";
                let i;
                for (i = 0; i < productForm.length; i++) {
                    let proElements = productForm.elements[i];
                    if (proElements.classList.contains('form-data')) {
                        if ((proElements.type === 'radio') && proElements.checked) {
                            txt = txt === "" ? proElements.value : txt + ' / ' + proElements.value;

                        }

                        if ((proElements.type === 'select-one')) {
                            txt = txt === "" ? proElements.value : txt + ' / ' + proElements.value;
                        }
                    }
                };
          		const prodOption = prodSelect.querySelector(`[data-value="${txt}"]`);
          		prodOption ? prodOption.selected = true : false;
                const productImage = product.querySelector(`[data-title="${txt}"]`);
                const activeImage = product.querySelector('img.active');
                if (productImage !== activeImage) {
                  productImage.classList.add('active');
                  activeImage.classList.remove('active');
                }          
            })
        }
//         if (cardSwatches.length) {
//             console.log(cardSwatches);
//             cardSwatches.forEach((swatch, swatchIndx) => {
//                 swatch.addEventListener('change', () => {
//                     prodSelect[swatchIndx].selected = true;
//                     const productImage = product.querySelector(`[data-title="${swatch.value}"]`);
//                     const activeImage = product.querySelector('img.active');
//                     if (productImage !== activeImage) {
//                         productImage.classList.add('active');
//                         activeImage.classList.remove('active');
//                     }
//                 });
//             })
//         }
    })
}


